module.exports = __webpack_public_path__ + "img/w3_subset_light.5fafea5a.png";